import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { SmoothScroll } from "@/components/SmoothScroll";
import { AuthProvider } from "@/context/AuthContext";
import { AuthCallback } from "@/components/AuthCallback";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import LandingPage from "@/pages/LandingPage";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import SeoLanding from "@/pages/SeoLanding";

/**
 * Arsitektur routing.
 *  /                        -> Landing page B2B (publik)
 *  /maintenance-ac-kantor   -> Halaman SEO/Google Ads (publik)
 *  /maintenance-ac-hotel    -> Halaman SEO/Google Ads (publik)
 *  /login                   -> Login admin (JWT email+password / Google)
 *  /admin                   -> Dashboard lead (terproteksi)
 *
 * Menambah halaman SEO baru: tambahkan konten di src/data/seoPages.js lalu
 * daftarkan <Route path="/slug" element={<SeoLanding slug="slug" />} /> di bawah.
 *
 * Rencana rute masa depan (arsitektur siap, belum dibuat kecuali diperlukan):
 *   /ac, /hvac, /electrical, /installation, /preventive-maintenance,
 *   /maintenance-contract, /maintenance-ac-kantor, /maintenance-ac-hotel,
 *   /maintenance-ac-gedung, /portfolio, /blog
 */
function AppRoutes() {
  const location = useLocation();
  // Deteksi callback OAuth (session_id di URL fragment) — sinkron saat render.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/ac" element={<SeoLanding slug="ac" />} />
      <Route path="/hvac" element={<SeoLanding slug="hvac" />} />
      <Route path="/electrical" element={<SeoLanding slug="electrical" />} />
      <Route path="/preventive-maintenance" element={<SeoLanding slug="preventive-maintenance" />} />
      <Route path="/service-ac" element={<SeoLanding slug="service-ac" />} />
      <Route path="/service-ac-rumah" element={<SeoLanding slug="service-ac-rumah" />} />
      <Route path="/ac-maintenance" element={<SeoLanding slug="ac-maintenance" />} />
      <Route path="/ac-installation" element={<SeoLanding slug="ac-installation" />} />
      <Route path="/maintenance-contract" element={<SeoLanding slug="maintenance-contract" />} />
      <Route path="/maintenance-ac-gedung" element={<SeoLanding slug="maintenance-ac-gedung" />} />
      <Route path="/maintenance-hvac" element={<SeoLanding slug="maintenance-hvac" />} />
      <Route path="/maintenance-ac-kantor" element={<SeoLanding slug="maintenance-ac-kantor" />} />
      <Route path="/maintenance-ac-hotel" element={<SeoLanding slug="maintenance-ac-hotel" />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SmoothScroll />
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
